import React, { useState, useEffect } from "react";

import Button from "react-bootstrap/Button";
import "./SubTopic.css";
import ButtonGroup from "react-bootstrap/ButtonGroup";
import Stack from "react-bootstrap/Stack";
import axios from "axios";
import { marked } from "marked";
import Spinner from "react-bootstrap/Spinner";
import {
  faChartBar,
  faSnowflake,
  faArrowAltCircleRight,
} from "@fortawesome/free-regular-svg-icons";
import { faRotateBack } from "@fortawesome/free-solid-svg-icons";
import { format } from "sql-formatter";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Modal from "react-bootstrap/Modal";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  Title,
  Tooltip,
  Legend,
  ArcElement,
  TimeScale,
  ScatterController,
} from "chart.js";
import "./CustomComponent.css";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  ArcElement,
  TimeScale,
  ScatterController,
  Title,
  Tooltip,
  Legend
);
import { Pie, Bar, Line, Scatter } from "react-chartjs-2";

export const SubTopic = (props) => {
  const [reader, setReader] = useState();
  const [hasRequested, setHasRequested] = useState(false);
  const [messageContent, setMessageContent] = useState("");
  const [modifiedChartOptions, setModifiedChartOptions] = useState();
  const [sqlQuery, setSqlQuery] = useState();
  const [showSQLData, setShowSQLData] = useState(false);
  const handleCloseSQLData = () => setShowSQLData(false);
  const [prompt, setPrompt] = useState();
  const [chart, setChart] = useState(null);
  const [retry, setRetry] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);

  if (props.report.generated_chart && !chart && !retry) {
    console.log("GOT IT");
    setChart(JSON.parse(props.report.generated_chart));
    setRetry(true);
  }

  const [generatedResponse, setGeneratedResponse] = useState(
    props.report.generated_response
  );

  function onClickSQL(evt) {
    // props.setShowSQLData(true);

    //format('SELECT * FROM tbl', { language: 'mysql' })
    // props.setSQLDataContent(
    //   format(props.sqlQuery, { language: "snowflake" })
    // );
    setShowSQLData(true);
    setSqlQuery(format(sqlQuery, { language: "snowflake" }));
  }

  useEffect(() => {
    if (chart && chart.options != undefined) {
      let new_chart = chart.options;
      new_chart.maintainAspectRatio = false;

      let total_in_dataset = chart.data.datasets.length;
      let modified_leged = {};
      modified_leged["maxWidth"] = 10000000000;
      modified_leged["display"] = true;
      if (total_in_dataset == 1) {
        modified_leged["position"] = "top";
      } else {
        modified_leged["position"] = "left";
      }
      modified_leged["position"] = "top";
      if (new_chart.plugins != undefined) {
        new_chart.plugins.legend = modified_leged;
      } else {
        new_chart.plugins = {};
        new_chart.plugins.legend = modified_leged;
      }
      setModifiedChartOptions(chart.options);
    }
  }, [chart]);

  function deleteSubTopic() {
    // console.log("report id", props.report.id);
    // console.log("topic id", props.report.topic_id);
    setIsDeleting(true);

    axios
      .post(
        process.env.REACT_APP_API_DOMAIN + "/deleteSubTopic",
        {
          subTopicId: props.report.id,
          reportId: props.report.topic_id,
        },
        {
          headers: {
            authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "application/json",
          },
        }
      )
      .then((response) => {
        props.setReportId(undefined);
        props.setReportId(props.report.topic_id);
        setIsDeleting(false);
      })
      .catch((error) => {
        console.log(error);
      });
  }
  function refreshSubTopic() {
    setRetry(true);

    setGeneratedResponse("");
    setMessageContent("");
    setChart(undefined);
  }
  useEffect(() => {
    const fetchData = async () => {
      let body = JSON.stringify({
        topicId: props.report.id,
        audience: props.report.audience,
        contentSize: props.report.content_size,
        dateRange: props.report.daterange,
        prompt: props.report.prompt,
        partnerName: props.partnerName,
        partnerId: props.partnerId,
        subTopicId: props.report.id,
      });
      const response = await fetch(
        process.env.REACT_APP_API_DOMAIN + "/generateSubTopic",
        {
          method: "POST",
          headers: {
            authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "application/json",
          },
          body: body, // Replace with your data
        }
      );
      const reader = response.body.getReader();
      var allData = "";
      if (reader != undefined) {
        while (true) {
          const { done, value } = await reader.read();
          if (done) {
            break;
          }
          const chunkString = new TextDecoder().decode(value);

          allData += chunkString;
          if (!allData.includes("$*END*$")) {
            const marked_version = marked.parse(allData);

            setMessageContent(marked_version);
            setGeneratedResponse(marked_version);
          } else {
            if (allData == "$*END*${}") {
              setMessageContent("PROMPT FAILED " + props.report.prompt);
            }
            // console.log(allData.split("$*END*$")[1]);

            try {
              let fullResults = JSON.parse(allData.split("$*END*$")[1]);
              let chartData = fullResults.ai_result.chart;

              setChart(chartData);
              setRetry(false);

              setPrompt(fullResults.ai_result.prompt);
              setSqlQuery(
                format(fullResults.ai_result.sqlQuery, {
                  language: "snowflake",
                })
              );

              props.setCompletedSubTopics((prevItems) => [
                ...prevItems,
                props.report.id,
              ]);
            } catch (error) {
              console.log("ERROR IN CHART", error);
              // Code to handle the error
            } finally {
              // Code that will always execute, regardless of whether an error occurred
            }
          }
        }
      }
    };

    if (props.partnerId != undefined && generatedResponse == "") {
      fetchData();
    } else {
      const marked_version = marked.parse(generatedResponse);

      setMessageContent(marked_version);
      setSqlQuery(props.report.sql_query);
      setPrompt(props.report.prompt);

      // props.setCompletedSubTopics((prevItems) => [...prevItems, props.id]);

      // if (props.report.generated_chart != "") {
      //   setChart(JSON.parse(props.report.generated_chart));
      // } else {
      //   setChart("");
      // }
    }
  }, [generatedResponse]);

  return (
    <div className="subTopicContainer">
      <Modal show={showSQLData} onHide={handleCloseSQLData} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>SQL Query</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <pre>{sqlQuery}</pre>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseSQLData}>
            Close
          </Button>{" "}
        </Modal.Footer>
      </Modal>
      <div>
        {" "}
        <div className="subTopicTitle">{props.report.title}</div>
        {/* <div className="presentationTitle">{props.report.prompt}</div> */}
        {/* <div>{props.report.prompt}</div> */}
      </div>
      <div className="subTopicSlide">
        {isDeleting ? (
          <div className="subTopicLoader">
            Deleting Slide<p>&nbsp;</p>
            <Spinner animation="border" variant="secondary" />
          </div>
        ) : messageContent == "" ? (
          <div className="subTopicLoader">
            Generating Analysis<p>&nbsp;</p>
            <Spinner animation="border" variant="secondary" />
          </div>
        ) : messageContent != "" && chart == "" ? (
          <div className="subTopicCardNoChart">
            <div
              dangerouslySetInnerHTML={{
                __html: messageContent,
              }}
            ></div>
          </div>
        ) : (
          <div className="subTopicCard">
            <div
              dangerouslySetInnerHTML={{
                __html: messageContent,
              }}
            ></div>
          </div>
        )}
        <p>&nbsp;</p>
        {isDeleting ? (
          <div> </div>
        ) : chart != null && chart.data != null ? (
          <div className="subTopicChart">
            {" "}
            {chart.type == "pie" ? (
              <Pie data={chart.data} options={modifiedChartOptions} />
            ) : chart.type == "line" ? (
              <Line data={chart.data} options={modifiedChartOptions} />
            ) : chart.type == "scatter" ? (
              <Scatter data={chart.data} options={modifiedChartOptions} />
            ) : (
              <Bar data={chart.data} options={modifiedChartOptions} />
            )}
          </div>
        ) : chart == "" ? (
          <div></div>
        ) : (
          <div className="subTopicLoader">
            {" "}
            Generating Chart<p>&nbsp;</p>
            <Spinner animation="border" variant="secondary" />
          </div>
        )}
      </div>
      <div>
        <Stack direction="horizontal" gap={11111}>
          {sqlQuery ? (
            <div>
              <Button onClick={onClickSQL} variant="link">
                <FontAwesomeIcon
                  className="subtopic_options"
                  icon={faSnowflake}
                  size="lg"
                />
              </Button>
            </div>
          ) : (
            <div></div>
          )}
          {generatedResponse && !props.isShare ? (
            <div className="promptView">
              <Button onClick={refreshSubTopic} variant="link">
                <FontAwesomeIcon
                  className="subtopic_options"
                  icon={faRotateBack}
                  size="lg"
                />
              </Button>
              {props.numSubTopics > 1 ? (
                <Button onClick={deleteSubTopic} variant="link">
                  <FontAwesomeIcon
                    className="subtopic_options"
                    icon={faTrash}
                    size="lg"
                  />
                </Button>
              ) : (
                <div></div>
              )}
            </div>
          ) : (
            <div></div>
          )}
          {messageContent != "" ? (
            <div className="slideNumberContainer">
              Slide {props.rowIndex + 1}
            </div>
          ) : (
            <div className="slideNumberContainer"></div>
          )}
        </Stack>
      </div>
    </div>
  );
};

export default SubTopic;
